import { Text as RNText, View } from 'react-native';

import { cn } from './cn';

export type StatusPillTone = 'active' | 'complete' | 'neutral';

export interface StatusPillProps {
  label: string;
  tone?: StatusPillTone;
  className?: string;
}

/** The "ACTIVE RUN" / "🔒 COMPLETE RUN" markers above a run title. */
export function StatusPill({ label, tone = 'active', className }: StatusPillProps) {
  return (
    <View
      className={cn(
        'flex-row items-center gap-1.5 self-start rounded-full border border-border bg-card px-2.5 py-1',
        className,
      )}
    >
      {tone === 'active' ? <View className="h-2 w-2 rounded-full bg-signal" /> : null}
      {tone === 'complete' ? <RNText className="text-[11px]">🔒</RNText> : null}
      <RNText className="font-accent text-[10px] uppercase tracking-[0.1em] text-foreground">
        {label}
      </RNText>
    </View>
  );
}
